import ApiRegiones from "@/services/ApiRegiones";
import Busqueda from "@/utils/Busqueda.js";

export default {
    data() {
        return {
            regiones: [],
        };
    },
    beforeMount() {
        this.regiones = this.buscarDatosRegiones();
    },
    methods: {
        buscarDatosRegiones() {
            return ApiRegiones.getRegionesYComunas();
        },
        limpiarNombreRegion(region) {
            return Busqueda.limpiarNombreRegion(region);
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/regiones.js